var fontWeight;

(function (fontWeight) {
  fontWeight["normal"] = "normal";
  fontWeight["medium"] = "500";
  fontWeight["bold"] = "bold";
  fontWeight["heavy"] = "900";
})(fontWeight || (fontWeight = {}));

export default fontWeight;